import {
  getRandomAddress1,
  getRandomAddress2,
  getRandomCity,
  getRandomCompany,
  getRandomCountry,
  getRandomCurrency,
  getRandomDate,
  getRandomEmail,
  getRandomFirstName,
  getRandomId,
  getRandomLastName,
  getRandomOrders,
  getRandomPhone,
  getRandomProductName,
  getRandomSource,
  getRandomState,
  getRandomTags,
  getRandomLifetimeValue,
  getRandomZipCode,
  getRandomOrderPrice,
} from "@tiny/components/src/utils/fakerUtils";
import { CustomAttributeDefinitionView } from "@tiny/api";

const BASE_HEADERS_BEFORE_CUSTOM = [
  "Email",
  "Phone Number",
  "First Name",
  "Last Name",
  "Source",
  "Status",
];

const BASE_HEADERS_AFTER_CUSTOM = [
  "Birthday",
  "Currency",
  "Country",
  "State/Province",
  "City",
  "Address 1",
  "Address 2",
  "Zip/Postal Code",
  "Company",
  "Number Of Orders",
  "Lifetime Value",
  "Latest Order ID",
  "Last Purchased Order",
  "Last Purchased Date",
  "Last Purchased Price",
  "Tags",
];

const STATUSES = ["Subscribed", "Unsubscribed", "Bounced", "Inactive", "Spam"];

function getSampleValueForType(dataType: string): string | number {
  switch (dataType) {
    case "INTEGER":
      return Math.floor(Math.random() * 1000);
    case "BOOLEAN":
      return Math.random() > 0.5 ? "true" : "false";
    case "DATE":
      return getRandomDate("MM/dd/yyyy");
    case "ARRAY":
      return "value1, value2, value3";
    case "STRING":
    default:
      return `sample_${Math.random().toString(36).substring(2, 7)}`;
  }
}

function generateDataRow(
  status: string,
  customAttributes: CustomAttributeDefinitionView[] = []
): (string | number)[] {
  const rowBeforeCustom: (string | number)[] = [
    getRandomEmail(),
    getRandomPhone(),
    getRandomFirstName(),
    getRandomLastName(),
    getRandomSource(),
    status,
  ];

  const customValues = customAttributes.map((attr) =>
    getSampleValueForType(attr.dataType)
  );

  const rowAfterCustom: (string | number)[] = [
    getRandomDate("MM/dd/yyyy"),
    getRandomCurrency(),
    getRandomCountry(),
    getRandomState(),
    getRandomCity(),
    getRandomAddress1(),
    getRandomAddress2(),
    getRandomZipCode(),
    getRandomCompany(),
    getRandomOrders(),
    getRandomLifetimeValue(),
    getRandomId(),
    getRandomProductName(),
    getRandomDate("MM/dd/yyyy"),
    getRandomOrderPrice(),
    getRandomTags(),
  ];

  return [...rowBeforeCustom, ...customValues, ...rowAfterCustom];
}

function escapeCSVValue(value: string | number): string {
  const str = String(value);
  if (
    str.includes(",") ||
    str.includes('"') ||
    str.includes("\n") ||
    str.includes("\r")
  ) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

export function getSampleCsvData(
  customAttributes: CustomAttributeDefinitionView[] = []
) {
  const headers = [
    ...BASE_HEADERS_BEFORE_CUSTOM,
    ...customAttributes.map((attr) => attr.attributeName),
    ...BASE_HEADERS_AFTER_CUSTOM,
  ];
  const dataRows = STATUSES.map((status) =>
    generateDataRow(status, customAttributes)
  );
  return [headers, ...dataRows]
    .map((row) => row.map(escapeCSVValue).join(","))
    .join("\r\n");
}
